import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ isAuthenticated, children }) => {

  if (!isAuthenticated || isAuthenticated === null) {
    return <Navigate to={"/"} />;
  }
 
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
